import SubmitFailed from '../../../Shared/SubmitFailed';
import SubmitSuccessful from '../../../Shared/SubmitSuccessful';
import { Status } from '../../../../hooks/fetch.hook';

function FormSubmitResult({
  id,
  submitStatus,
  submitErrorCode,
  successText,
  failedText,
  dismissButtonText,
  onDismiss,
}: {
  id?: string;
  submitStatus: Status;
  submitErrorCode: number | undefined;
  successText: string;
  failedText: string;
  dismissButtonText: string;
  onDismiss: () => void;
}) {
  return (
    <div id={id} className="form-submit-result" role="alert">
      {submitStatus === Status.failed && submitErrorCode !== 400 && (
        <>
          <SubmitFailed failedText={failedText} />
          <button
            className="btn btn-primary d-block mx-auto"
            onClick={() => {
              onDismiss();
            }}
          >
            {dismissButtonText}
          </button>
        </>
      )}
      {submitStatus === Status.success && <SubmitSuccessful successText={successText} />}
    </div>
  );
}

export default FormSubmitResult;
